import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 容器
const BaseContainer = () => import('@/basecomponents/BaseContainer/BaseContainer.vue');
// 数字城底座-布局页
const BaseLayout = () => import('@/basecomponents/BaseLayout/BaseLayout.vue');
// 数字校园-布局页
const BaseCampusLayout = () => import('@/basecomponents/BaseCampusLayout/BaseCampusLayout.vue');

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Login'
    },
    {
      path: '/core',
      component: () => import('@/views/core.vue')
    },
    {
      path: '/play',
      component: () => import('@/views/Player.vue')
    },
    { // 登录页
      path: '/Login',
      name: 'Login',
      component: () => import('@/views/Login/Login.vue')
    },
    { // 登录页
      path: '/test',
      name: 'test',
      component: () => import('@/views/test2.vue')
    },
    { // 首页
      path: '/Home',
      name: 'Home',
      component: () => import('@/views/Home/Home.vue')
    },
    { // 首页
      path: '/Obj',
      name: 'Obj',
      component: () => import('@/views/Project/ProjectEditor/Project_ObjDetailSingle.vue'),
    },
    { // 数字城建造编辑器
      path: '/Project',
      name: 'Project',
      component: BaseLayout,
      redirect: '/Project/ProjectEditor/Resource',
      children: [
        { // 资源服务
          path: 'ProjectEditor/:editorType',
          name: 'ProjectEditor',
          component: () => import('@/views/Project/ProjectEditor/ProjectEditor.vue')
        },
        { // 数字城建造编辑器-对象编辑
          path: 'ObjectEditor',
          name: 'ObjectEditor',
          component: () => import('@/views/Project/ObjectEditor/ObjectEditor.vue'),
          meta: {
            isBackProject: true
          }
        },
        { // 数字城建造编辑器-资源编辑
          path: 'ResourceEditor',
          name: 'ResourceEditor',
          component: () => import('@/views/Project/ResourceEditor/ResourceEditor.vue'),
          meta: {
            isBackProject: true
          }
        },
        { // 数字城建造编辑器-资源编辑
          path: 'Server',
          name: 'Server',
          component: () => import('@/views/Project/ProjectServer/ProjectServer.vue'),
          meta: {
            isBackProject: true
          }
        },
      ]
    },
    { // 工具箱
      path: '/Toolbox',
      name: 'Toolbox',
      component: BaseLayout,
      redirect: '/Toolbox/Metadata',
      children: [
        { // 工具箱-元数据组件
          path: 'Metadata',
          component: BaseContainer,
          children: [
            { // 工具箱-元数据组件
              path: '',
              name: 'Metadata',
              component: () => import('@/views/Toolbox/Metadata/Metadata.vue')
            },
            { // 工具箱-元数据组件-详情
              path: 'MetaDetail',
              name: 'MetaDetail',
              component: () => import('@/views/Toolbox/Metadata/MetaDetail/MetaDetail.vue'),
              meta: {
                isBack: true
              }
            }
          ]
        },
        { // 工具箱-服务组件
          path: 'ServiceComponent',
          component: BaseContainer,
          children: [
            { // 工具箱-服务组件
              path: '',
              name: 'ServiceComponent',
              component: () => import('@/views/Toolbox/ServiceComponent/ServiceComponent.vue')
            },
            { // 工具箱-服务组件-详情
              path: 'ComponentDetail',
              name: 'ComponentDetail',
              component: () => import('@/views/Toolbox/ServiceComponent/ComponentDetail/ComponentDetail.vue'),
              meta: {
                isBack: true
              }
            }
          ]
        },
        { // 工具箱-物联产品
          path: 'IotProduct',
          component: BaseContainer,
          children: [
            { // 工具箱-元数据组件
              path: '',
              name: 'IotProduct',
              component: () => import('@/views/Toolbox/IotProduct/IotProduct.vue')
            },
          ]
        },
        { // 工具箱-任务模板
          path: 'TaskTemplate',
          component: BaseContainer,
          children: [
            { // 工具箱-元数据组件
              path: '',
              name: 'TaskTemplate',
              component: () => import('@/views/Toolbox/TaskTemplate/TaskTemplate.vue')
            },
          ]
        },
        { // 工具箱-任务模板
          path: 'DTOTemplate',
          component: BaseContainer,
          children: [
            { // 工具箱-元数据组件
              path: '',
              name: 'DTOTemplate',
              component: () => import('@/views/Toolbox/DTOTemplate/DTOTemplate.vue')
            },
          ]
        },
        { // 工具箱-任务模板
          path: 'ProjectDTOTemplate',
          component: BaseContainer,
          children: [
            { // 工具箱-元数据组件
              path: '',
              name: 'ProjectDTOTemplate',
              component: () => import('@/views/Toolbox/ProjectDTOTemplate/ProjectDTOTemplate.vue')
            },
          ]
        },
        { // 工具箱-对象工具
          path: 'Object',
          name: 'Object',
          component: () => import('@/views/Toolbox/Object/Object.vue')
        },
        { // 工具箱-场景工具
          path: 'Scene',
          name: 'Scene',
          component: () => import('@/views/Toolbox/Scene/Scene.vue')
        },
      ]
    },
    { // 分析中心
      path: '/Analysis',
      name: 'Analysis',
      component: BaseLayout,
      redirect: '/Analysis/TaskFlow',
      children: [
        { // 分析中心-分析任务流
          path: 'TaskFlow',
          name: 'TaskFlow',
          component: () => import('@/views/Analysis/TaskFlow/TaskFlow.vue'),
        }
      ]
    },
    { // 服务平台
      path: '/Service',
      name: 'Service',
      component: BaseLayout,
      redirect: '/Service/ServiceCenter',
      children: [
        { // 服务平台-主页
          path: 'ServiceCenter',
          name: 'ServiceCenter',
          component: () => import('@/views/Service/ServiceCenter/ServiceCenter.vue')
        },
        { // 服务平台-详情
          path: 'ServiceDetail',
          name: 'ServiceDetail',
          component: () => import('@/views/Service/ServiceDetail/ServiceDetail.vue'),
          meta: {
            isBack: true
          }
        },
        { // 服务平台-详情
          path: 'DataDetail',
          name: 'DataDetail',
          component: () => import('@/views/Service/DataDetail/DataDetail.vue'),
          meta: {
            isBack: true
          }
        }
      ]
    },
    { // 应用门户
      path: '/Application',
      name: 'Application',
      component: BaseLayout,
      redirect: '/Application/PortalHome',
      children: [
        { // 应用门户-主页
          path: 'PortalHome',
          name: 'PortalHome',
          component: () => import('@/views/Application/PortalHome/PortalHome.vue')
        }
      ]
    },
    { // 默认应用
      path: '/DefaultApply',
      name: 'DefaultApply',
      component: () => import('@/views/Application/DefaultApply/DefaultApply.vue')
    },
    {
      path: '/editor',
      name: 'Editor',
      component: () => import('@/components/pages/Editor')
    },
    {
      path: '/projectList',
      name: 'projectList',
      component: () => import('@/components/pages/project/ProjectList.vue')
    },
    {
      path: '/object',
      name: 'object',
      component: () => import('@/components/pages/editor/project/component_Object.vue')
    },
    {
      path: '/createModel',
      name: 'createModel',
      component: () => import('@/components/pages/editor/project/component_CreateModel.vue')
    },
    {
      path: '/task',
      name: 'task',
      component: () => import('@/components/pages/editor/project/component_Task.vue')
    },
    {
      path: '/taskInstance',
      name: 'taskInstance',
      component: () => import('@/components/pages/editor/project/component_TaskInstance.vue')
    },
    {
      path: '/taskCenter',
      name: 'taskCenter',
      component: () => import('@/views/Analysis/TaskFlow/TaskFlowCenter.vue')
    },
    // {
    //   path: '/notebook',
    //   name: 'notebook',
    //   component: () => import('@/notebook/index.vue')
    // },
    { // 数字校园
      path: '/DigitalCampusBG',
      name: 'DigitalCampusBG',
      component: BaseCampusLayout,
      redirect: '/DigitalCampusBG/CampusEat',
      children: [
        { // 数字校园-吃在同济
          path: 'CampusEat',
          component: BaseContainer,
          children: [
            { // 数字校园-吃在同济-主页
              path: '',
              name: 'CampusEat',
              component: () => import('@/views/tongji/tongji.vue'),
            }
          ]
        }
      ]
    },
    {
      path: '/commonTile',
      name: 'cesium',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/basecomponents/cesium.vue')
    },
    {
      path: '/dtScene',
      name: 'dtScene',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/Project/ProjectEditor/ProjectEditor2.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js